var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGameShows = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84082 9.97255H11.159C11.159 10.5351 10.703 10.9911 10.1405 10.9911H6.85941C6.29686 10.9911 5.84082 10.5351 5.84082 9.97255Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1122 6.26395C11.801 6.26395 11.5487 6.51608 11.5485 6.82723C11.5485 6.96605 11.6825 7.19197 11.6825 7.19163L10.3162 8.43407L8.79362 7.05002C9.05779 6.88502 9.13816 6.53709 8.97316 6.27292C8.80816 6.00875 8.46023 5.92838 8.19606 6.09338C7.9319 6.25838 7.85152 6.60631 8.01652 6.87048C8.05831 6.93737 8.11365 6.99476 8.179 7.03893L6.67279 8.43407L5.2877 7.17462C5.2877 7.17462 5.45152 6.93168 5.45152 6.77757C5.45115 6.46668 5.19885 6.21496 4.88796 6.2153C4.57706 6.21568 4.32534 6.46798 4.32568 6.77887C4.32606 7.08976 4.57836 7.34148 4.88925 7.34114C4.94442 7.34108 4.99928 7.33289 5.05206 7.31689L5.4373 8.43404L5.86 9.66017H11.1786L11.5801 8.43404C11.5801 8.43404 11.9272 7.35818 11.9244 7.35818C12.2179 7.46143 12.5394 7.30723 12.6427 7.01378C12.7459 6.72033 12.5917 6.39875 12.2983 6.2955C12.2385 6.27447 12.1756 6.26367 12.1121 6.26358L12.1122 6.26395Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43041 8.29177C2.47975 6.82559 3.06003 5.42723 4.06328 4.35691L4.06015 4.35412L2.34225 2.63622C0.883938 4.1636 0.0486208 6.18056 0 8.29177H2.42937H2.43041Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35707 4.06328C5.42733 3.06012 6.82552 2.47983 8.29158 2.43041C8.29138 2.42914 8.29138 2.42785 8.29158 2.42658V0C6.18063 0.0486208 4.16396 0.883823 2.63672 2.3419L4.35428 4.06015L4.35707 4.06328Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6429 12.9364C11.5726 13.9398 10.1742 14.5202 8.70801 14.5696C8.70821 14.5709 8.70821 14.5721 8.70801 14.5734V17C10.8197 16.9519 12.8373 16.1165 14.3649 14.6578L12.647 12.9395L12.6429 12.9364Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29179 14.5696C6.82543 14.5203 5.42692 13.9398 4.35655 12.9364L4.35411 12.9395L2.63623 14.6578C4.16388 16.1165 6.18144 16.9519 8.29319 17V14.5734C8.2925 14.5722 8.29205 14.5709 8.29179 14.5696Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06322 12.6428C3.06006 11.5725 2.47977 10.1743 2.43035 8.70824H0.000976562C0.0488215 10.8198 0.883794 12.8374 2.34219 14.3652L4.06009 12.6469C4.06078 12.6453 4.06187 12.6439 4.06322 12.6428Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5694 8.70824C14.5201 10.1744 13.9398 11.5728 12.9365 12.6431C12.9377 12.6437 12.9388 12.6445 12.9397 12.6455L14.6576 14.3652C16.1163 12.8375 16.9517 10.82 16.9998 8.70824H14.5704H14.5694Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9365 4.35724C13.9397 5.4275 14.52 6.8257 14.5694 8.29176H16.9988C16.9504 6.18081 16.1154 4.164 14.6576 2.63655L12.9397 4.35446L12.9365 4.35724Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70801 2.43041C10.1742 2.47975 11.5726 3.06003 12.6429 4.06328L12.6457 4.06015L14.3632 2.3419C12.8359 0.883737 10.8191 0.0485346 8.70801 0V2.42658C8.70821 2.42785 8.70821 2.42914 8.70801 2.43041Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGameShows);
export default ForwardRef;